/**
 * Helpers for navigation when the app is embedded in a mobile WebView wrapper.
 * Pages import these from `src/functions/navigationHelper`.
 */
 
function truthyParam(v) {
  if (v == null) return false;
  const s = String(v).trim().toLowerCase();
  return s === "1" || s === "true" || s === "yes" || s === "y" || s === "on";
}

/**
 * Detect whether the current session is running inside a mobile app wrapper.
 * Supports query param signals and an optional user flag (if present in auth state).
 */
export function isFromMobileApp(search, user) {
  try {
    if (user && (user.fromMobileApp === true || user.isFromMobileApp === true)) return true;
    const qs = typeof search === "string" ? search : "";
    const params = new URLSearchParams(qs.startsWith("?") ? qs : `?${qs}`);
    const candidates = [
      params.get("fromMobileApp"),
      params.get("from_mobile_app"),
      params.get("mobileApp"),
      params.get("mobile_app"),
      params.get("inApp"),
      params.get("in_app"),
      params.get("webview"),
      params.get("app"),
    ];
    return candidates.some(truthyParam);
  } catch {
    return false;
  }
}

export function isExtramileplayUrl(url) {
  try {
    const u = new URL(String(url), window.location.href);
    const host = String(u.hostname || "").toLowerCase();
    return host === "extramileplay.com" || host.endsWith(".extramileplay.com");
  } catch {
    return false;
  }
}

/**
 * Navigate to an external URL.
 * - When embedded in a React Native WebView wrapper, ask the wrapper to open it.
 * - Otherwise, fall back to normal browser navigation.
 */
export function navigateExternalUrl(url, fromMobileApp = false, mode = "assign") {
  const href = String(url || "").trim();
  if (!href) return;

  const navMode = mode === "replace" ? "replace" : "assign";

  if (fromMobileApp && typeof window !== "undefined") {
    const rn = window.ReactNativeWebView;
    if (rn && typeof rn.postMessage === "function") {
      // Send a small, forward-compatible payload to the wrapper.
      rn.postMessage(
        JSON.stringify({
          type: "externalNavigation",
          url: href,
          mode: navMode,
        })
      );
      return;
    }
  }

  if (navMode === "replace") {
    window.location.replace(href);
  } else {
    window.location.assign(href);
  }
}

